<template>
    <nav class="navbar navbar-expand navbar-light bg-light" id="main-navbar">
        <img class="navbar-brand" src="@/assets/ewlogo.png" alt="Logo" />
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
            <li v-if="isForecastInventoryLoaded" class="nav-item">
                <a class="nav-link" href="#" @click="$emit('open-forecast-clicked')"><img src="@/assets/ionic/globe-3x.png" alt="Open forecast" /></a>
            </li>

            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="@/assets/ionic/map-marker-3x.png" alt="My points" /></a>
                <div class="dropdown-menu">
                    <a v-if="isForecastLoaded" class="dropdown-item" href="#" @click="addPointClicked">Add point...</a>
                    <a class="dropdown-item" href="#" @click="managePointsClicked">Manage points...</a>
                    <div class="dropdown-divider"></div>       
                    <a v-for="point in getPoints" :key="point.id" class="dropdown-item" :data-pointid="point.id" href="#" @click="userPointClicked">{{ point.name }}</a>
                </div>
            </li>

            <li v-if="isForecastLoaded && hasPoints" class="nav-item">
                <a class="nav-link" href="#" @click="$emit('summary-clicked')"><img src="@/assets/ionic/paper-3x.png" alt="Summary" /></a>
            </li>

            <li v-if="isForecastLoaded && multipleMonthsAvailable" class="nav-item">
                <a class="nav-link" href="#" @click="$emit('report-clicked')"><img src="@/assets/ionic/bar-chart-3x.png" alt="Report" /></a>
            </li>
                                
            <li v-if="isForecastLoaded" class="nav-item">
                <a class="nav-link" href="#" @click="$emit('forecast-info-clicked')"><span class="badge badge-primary">{{ forecastInfo }}</span></a>
            </li>            
        </ul>
        <ul class="navbar-nav mr-right">            
            <li class="nav-item">
                <a href="#" class="nav-link" @click="$emit('settings-clicked')"><img src="@/assets/ionic/cog-3x.png"/></a>
            </li>
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img src="@/assets/ionic/help-3x.png" alt="Settings" />
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="#" @click="$emit('subscription-clicked')">Subscription</a>
                    <template v-if="isDebug">
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#" @click="$emit('display-map-urls')">Display map URLs</a>                        
                    </template>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" @click="$emit('about-clicked')">About ExtendWeather Online</a>
                    <div class="dropdown-divider"></div>      
                    <a class="dropdown-item" href="#" @click="$emit('logout-clicked')">Log out</a>
                </div>
            </li>              
        </ul>
        </div>
    </nav>    
</template>

<script>
import events from '@/lib/events.js'
import config from '@/lib/config.js'

export default {
    name: 'Toolbar',
    computed: {
        isForecastInventoryLoaded() {
            return this.$store.state.forecastInventory != null
        },
        getPoints() {
            return this.$store.state.userPoints
        },
        hasPoints() {
            return this.$store.state.userPoints.length > 0
        },
        isForecastLoaded() {
            return this.$store.state.forecast != null
        },
        multipleMonthsAvailable() {
            return this.$store.state.user.numMonths > 1
        },
        forecastInfo() {
            let result = ''
            if (this.$store.state.forecast != null)
                result = this.$store.state.forecast.forecastID.toString(true)
            return result
        },
        isDebug() {
            return config.isDebug()
        }
    },
    methods: {
        userPointClicked(e) {
            let id = e.target.dataset.pointid
            let point = this.$store.state.userPoints.find((p) => p.id === id)
            if (point != null) {
                events.$emit(events.ACTION_PAN_TO, [point.lat, point.lon])
            }
        },
        addPointClicked() {
            events.$emit(events.ACTION_ADD_POINT, 0, 0, 'New point')
        },
        managePointsClicked() {
            events.$emit(events.ACTION_MANAGE_POINTS)
        },
        reportToolbarSizeChanged() {
            setTimeout(() => {
                let toolbarHeight = document.getElementById('main-toolbar').clientHeight || 0
                this.$store.commit('setToolbarHeight', toolbarHeight)
            }, 200)        
        }
    },
    updated() {
        this.reportToolbarSizeChanged()        
    },
    mounted() {
        window.addEventListener('resize', () => { this.reportToolbarSizeChanged() })
    }
}
</script>
    
<style>
    .dropdown-menu {
        z-index: 1200;
    }

    #main-navbar {
        background-color: rgb(255, 255, 255) !important;    
        padding: 0.2rem !important;
    }
</style>
